export enum InvoiceSection {
  TODO = 'todo',
  TO_COLLECT = 'to-collect',
  COLLECTED = 'collected',
}

export enum InvoiceCommissionValueType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
